/**
 * Checks if user has access to given feature
 * @param feature Feature id
 * @returns true if user has access
 */
export default function hasFeature(feature: string): boolean {
  const params = new URLSearchParams(window.location.search.toLowerCase());
  return params.get(`unlock${feature.toLowerCase()}`) !== null;
}
